import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { SMART_LINK } from '../data/site';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <div className="container header__inner">
        <Link to="/" className="header__brand">
          <img
            src="/images/logo_son.png"
            alt=""
            className="header__logo"
            width="44"
            height="44"
          />
          <span className="header__name">Travel Istanbul</span>
        </Link>

        <nav className="header__nav" aria-label="Ana menü">
          <NavLink to="/" className="header__link" end>
            Ana Sayfa
          </NavLink>
          <NavLink to="/contact" className="header__link">
            İletişim
          </NavLink>
          <a
            href={SMART_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="header__cta"
          >
            <span className="header__cta-long">Uygulamayı İndir</span>
            <span className="header__cta-short">İndir</span>
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
